// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	recaptcha_site_key: '6LfB_mIhAAAAAF0ZCotU6IFxRhR8FakEvRricrCo',
	production: false,
	webBaseUrl: 'https://booking-test.rentastore.co.za',
	portalBaseUrl: 'https://portal-dev.rentastore.co.za',
/* 	webBaseUrl: 'https://booking.rentastore.co.za',
	portalBaseUrl: 'https://portal.rentastore.co.za', */

	// MailChimp Newsletter configuration
	mailchimpUrl: 'https://rentastore.us13.list-manage.com/subscribe/post',
	mailchimpUserId: 'a696f656183195751e2c27e61',
	mailchimpListId: 'eed9c4afed',
	mailchimpHiddenField: 'b_a696f656183195751e2c27e61_7a1161037d' // The hidden bot prevention field
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
